// Major
import React from "react";
import { Link } from "react-router-dom";

// Styles
import { StyledSectionContainer } from "styles/components/SectionContainer/index.styles";
import theme from "assets/theme";
import MKBox from "components/MKBox";

// components
import { ImageContainer } from "styles/components/imageContainer";
import HeaderContainer from "styles/components/headerContainer";
import MKTypography from "components/MKTypography";
import FourSquareBasicComponent from "styles/components/fourSqaureBasicComponent";
import useMediaQueries from "utils/mediaQueries.utils";
const KeyMechanics = ({ ...props }) => {
  const { title, cards, cta } = props;
  const { isLg, isMd } = useMediaQueries();
  const gridSection = (item) => {
    return (
      <>
        <ImageContainer
          image={item.imageUrl}
          alt={item.title}
          cssProps={{
            width: "4.5rem",
            height: "auto",
            margin: "auto",
            display: "flex",
          }}
        />
        <HeaderContainer title={item.title} component="h3" variant="h3" textColor={theme.palette.primary.main} cssProps={{ textAlign: "center" }} />
        <MKTypography component={"p"} variant={isLg ? "body1" : "body2"} sx={{ textAlign: "center" }} color="primary">
          {item.description}
        </MKTypography>
      </>
    );
  };

  const hexToRgb = (hex) => {
    let r = 0,
      g = 0,
      b = 0;
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }
    return `rgb(${r}, ${g}, ${b})`;
  };

  return (
    <StyledSectionContainer id="ketamine-therapist-hub-key-mechanics">
      <HeaderContainer
        cssProps={{ textAlign: "center", justifyContent: "center", marginTop: "0rem !important", marginBottom: "2rem" }}
        highlightText={"Works"}
        highlightColor={theme.palette.accent.main}
        title={title}
        component={"h2"}
        variant={"h1"}
        textColor={theme.palette.white.main}
      />

      <FourSquareBasicComponent
        component1={gridSection(cards[0])}
        component2={gridSection(cards[1])}
        component3={gridSection(cards[2])}
        component4={gridSection(cards[3])}
        dividerColor={theme.palette.primary.main}
        imageURL={"https://almadelic-assets.s3.us-east-2.amazonaws.com/almadelicButterflies/alma_butterfly_gold.svg"}
        cssProps={{
          backgroundColor: theme.palette.white.main,
          boxShadow: `0px 0px 10px 5px ${hexToRgb(theme.palette.primary.main)}`,
          border: `3px solid ${theme.palette.primary.main}`,
        }}
      />
      {cta && (
        <MKBox sx={{ textAlign: "center", mt: 3 }}>
          <MKTypography
            component={Link}
            to={cta.link}
            variant="body1"
            sx={{
              color: theme.palette.accent.main,
              textDecoration: "underline",
              "&:hover": { color: theme.palette.white.main },
            }}
          >
            {cta.text}
          </MKTypography>
        </MKBox>
      )}
      <MKBox
        component="img"
        src="https://almadelic-assets.s3.us-east-2.amazonaws.com/almadelicButterflies/background+watermark+(500+x+200+px).webp"
        sx={{
          position: "absolute",
          bottom: 0,
          right: isLg ? -300 : isMd ? -200 : -100,
          zIndex: -1,
          pointerEvents: "none",
        }}
      />
      <MKBox
        component="img"
        src="https://almadelic-assets.s3.us-east-2.amazonaws.com/almadelicButterflies/background+watermark+(500+x+200+px).webp"
        sx={{
          position: "absolute",
          top: 0,
          left: isLg ? -300 : isMd ? -200 : -100,
          zIndex: -1,
          pointerEvents: "none",
          transform: "scaleX(-1)",
        }}
      />
    </StyledSectionContainer>
  );
};

export default KeyMechanics;
